@let isNew =
  pagesEc.plugins.currentEntityPlugin.feature.selectors.isCreating().asSignal();
@let name = editingPageNameSg();
@let alias = editingPageAliasSg();
@let canGetStarted = canGetStartedSg();

@if (isNew) {
  <atn-ds-centered-overlay
    type="narrow"
    class="atn-mosaic-page-setup-dialog"
  >
    <atn-ds-widget title="Setup Page">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-mosaic-page-setup-dialog__body">
        <atn-ds-text
          label="Name"
          placeholder="Enter a name"
          [value]="name"
          (change)="updatePageSetupInfo('name', $event ?? '')"
        />
        <atn-ds-text
          label="Alias"
          placeholder="Enter an alias"
          [value]="alias"
          (change)="updatePageSetupInfo('alias', $event ?? '')"
        />
      </div>

      <div
        footer
        class="atn-mosaic-page-setup-dialog__footer"
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          [disabled]="!canGetStarted"
          (click)="getStartedButtonClickHandler()"
        >
          Get Started
        </atn-ds-button>
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
